import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/marketplace/inventory/store/inventorySlice/initialState.ts'

const inventorySlice = createSlice({
  name: 'marketplaceInventory',
  initialState,
  reducers: {
    setIsBulkUpdateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isBulkUpdateModalOpen = action.payload
    },
    setAdjustVariantId: (state, action: PayloadAction<number | null>) => {
      state.adjustVariantId = action.payload
    },
    setMovementsVariantId: (state, action: PayloadAction<number | null>) => {
      state.movementsVariantId = action.payload
    },
    setMarketplaceId: (state, action: PayloadAction<string | null>) => {
      state.marketplaceId = action.payload
    },
    setCommercialAllyId: (state, action: PayloadAction<string | null>) => {
      state.commercialAllyId = action.payload
    },
    setThreshold: (state, action: PayloadAction<number>) => {
      state.threshold = action.payload
    },
    reset: () => initialState
  }
})

export const marketplaceInventoryActions = inventorySlice.actions
export const { reducer: marketplaceInventoryReducer } = inventorySlice
